import React, { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/authSlice";
import { useEffect } from "react";
import { AiFillSetting } from "react-icons/ai";
import { MdLogout } from "react-icons/md";
import Picture from "../../assets/images/image1.png";

const AvatarDropdown = () => {
  const cookies = document.cookie.split(";").reduce((prev, curr) => {
    const [name, value] = curr.trim().split("=");
    prev[name] = value;
    return prev;
  }, {});

  const [myVariable, setMyVariable] = useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = useState();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const trigger = useRef(null);
  const dropdown = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const login = `${window.globalConfig.BASE_URL2}/api/Login`;
  const users = `${window.globalConfig.BASE_URL2}/api/Users`;

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    let variableValue;
    const cookies = document.cookie.split(";"); //Get all cookies as an array

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();

      //Check if the cookie contains the variable you're looking for
      if (cookie.startsWith("ID=")) {
        variableValue = cookie.substring("ID=".length, cookie.length);
        setMyVariable(variableValue);
        break;
      }
    }
    const handlePreview = () => {
      const imageUrl = `${users}/ProfilePicture?UserID=${variableValue}&Random=${new Date()}`;
      fetch(imageUrl, {
        mode: "cors",
        credentials: "include",
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Error Image");
          }
          return response.arrayBuffer();
        })
        .then((buffer) => {
          const blob = new Blob([buffer], { type: "image/jpeg" }); //Update the 'type' accordingly based on your image format
          const previewUrl = URL.createObjectURL(blob);
          setImagePreviewUrl(previewUrl);
        })
        .catch((error) => {
          console.error("Error fetching the image:", error);
        });
    };

    handlePreview();
  }, [cookies.ProfilePicture]);

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(imagePreviewUrl);
    };
  }, [imagePreviewUrl]);

  const handleLogout = () => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${login}/Logout`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({}),
        });

        sessionStorage.clear();
        dispatch(logout());
        setTimeout(() => {
          document.cookie = `Redirect=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          navigate("/login");
        }, 1000);
      } catch (error) {
        console.log("Error fetching data:", error);
      }
    };

    fetchData();
  };
  //close on click outside
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!dropdown.current) return;
      if (
        !isDropdownOpen ||
        dropdown.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      setIsDropdownOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  //close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!isDropdownOpen || keyCode !== 27) return;
      setIsDropdownOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  return (
    <div className="relative inline-block text-left">
      <div ref={trigger}>
        <button
          onClick={toggleDropdown}
          type="button"
          className="inline-flex items-center px-0 md:px-2.5 py-1.5 text-sm font-medium rounded-md text-gray-700 "
          id="options-menu"
          aria-expanded="true"
          aria-haspopup="true"
        >
          {imagePreviewUrl ? (
            <img
              className="w-8 h-8 rounded-full"
              src={imagePreviewUrl}
              alt="Your Avatar"
            />
          ) : (
            <>
              <img
                className="w-8 h-8 rounded-full"
                src={Picture}
                alt="profile"
              />
            </>
          )}
        </button>
      </div>

      {isDropdownOpen && (
        <div
          className="origin-top-right absolute hover:ring-1 right-0 mt-0 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
          ref={dropdown}
        >
          <div className="py-1" role="none">
            <Link
              to="/profile-setting"
              className="block px-4 py-2  hover:bg-gray-100 w-full text-left"
              role="menuitem"
            >
              <div className="flex items-center gap-x-2">
                <AiFillSetting className="w-4 h-4 text-gray-700" />

                <h1 className="text-sm text-gray-700 font-medium">
                  Profile Setting
                </h1>
              </div>
            </Link>

            <button
              onClick={handleLogout}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left"
              role="menuitem"
            >
              <div className="flex items-center gap-x-2">
                <MdLogout className="w-4 h-4 text-gray-700" />
                <h1 className="text-sm text-gray-700 font-medium">Logout</h1>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarDropdown;
